export const sendBrowserNotification = async (title: string, body: string) => {
  if (typeof window === 'undefined' || !window['Notification']) {
    console.log('Notification отсутсвует в среде выполнения');
    return;
  }
  try {
    let permission = Notification.permission;
    if (permission === 'denied') return;
    if (permission === 'default') {
      permission = await Notification.requestPermission();
    }
    if (permission !== 'granted') return;
    new Notification(title, { body, tag: 'solution' });
  } catch (err: unknown) {
    if (err instanceof Error) console.error(err.message);
    else console.error(err);
  }
};
